import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom-v5-compat";
import Icon from "./Icon";
import { url } from "../utils";

type BackButtonProps = Readonly<{
  previousPageUrl?: string;
}>;

function BackButton({ previousPageUrl }: BackButtonProps) {
  const navigate = useNavigate();

  const goBack = () => {
    if (previousPageUrl) {
      navigate(url(previousPageUrl));
    } else {
      navigate(-1);
    }
  };

  return (
    <button className="back-button" onClick={goBack} type="button">
      <Icon name="icon-eh-arrow-left" />
      <span>
        <FormattedMessage id="label.go_back" />
      </span>
    </button>
  );
}

export default BackButton;
